import { useQuery } from '@tanstack/react-query'

import { useGoalsServiceGoalsControllerGetStepsKey } from '@/__generated__/queries'
import type { GoalStepData } from '@/__generated__/requests'
import { OpenAPI } from '@/__generated__/requests/core/OpenAPI'
import { request as __request } from '@/__generated__/requests/core/request'

function getGoalSteps(goalId: number): Promise<GoalStepData[]> {
  return __request(OpenAPI, {
    method: 'GET',
    path: {
      goalId,
    },
    url: '/goal/{goalId}/steps',
  })
}

export function useGoalSteps(goalId: number, enabled = true) {
  return useQuery<GoalStepData[]>({
    enabled,
    queryFn: () => getGoalSteps(goalId),
    queryKey: [useGoalsServiceGoalsControllerGetStepsKey, { goalId }],
  })
}
